import { EMediaQuery } from '@NGUtils/enums';
import { mq } from '@NGUtils/functions';
import styled, { css } from 'styled-components';

export const StyledCardList = styled.ul`
	display: flex;

	list-style: none;

	height: 55%;

	gap: 21px;

	& > li {
		width: calc(((1 / 3) * 100%) - 14px);

		${mq(
			EMediaQuery.xl,
			css`
				width: calc(((1 / 2) * 100%) - 14px);
			`
		)}
	}

	${mq(
		EMediaQuery.md,
		css`
			flex-direction: column;
			height: auto;

			gap: 0;

			height: 60%;
			justify-content: center;

			gap: 22px;

			& > li {
				width: 100%;
				display: flex;
				justify-content: center;
			}
		`
	)}

	${mq(
		EMediaQuery.sm,
		css`
			height: auto;
			gap: 16px;
		`
	)}
`;
